// Some set operations
export function union<P>(setA: Set<P>, setB: Set<P>): Set<P> {
	const result = new Set(setA);
	for (const elem of setB) result.add(elem);
	return result;
}

export function intersection<P>(setA: Set<P>, setB: Set<P>): Set<P> {
	const result = new Set<P>();
	for (const elem of setB) if (setA.has(elem)) result.add(elem);
	return result;
}

export function symmetricDifference<P>(setA: Set<P>, setB: Set<P>): Set<P> {
	const result = new Set(setA);
	for (const elem of setB)
		if (result.has(elem)) result.delete(elem);
		else result.add(elem);
	return result;
}

export function difference<P>(setA: Set<P>, setB: Set<P>): Set<P> {
	const result = new Set(setA);
	for (const elem of setB) result.delete(elem);
	return result;
}

export function map<P, R>(set: Set<P>, f: (e: P) => R): Set<R> {
	const result = new Set<R>();
	for (const elem of set) result.add(f(elem));
	return result;
}

export function reduce<P, R>(set: Set<P>, f: (r: R, e: P) => R, initial: R): R {
	let result = initial;
	for (const elem of set) result = f(result, elem);
	return result;
}

export function filter<P>(set: Set<P>, f: (e: P) => boolean): Set<P> {
	const result = new Set<P>();
	for (const elem of set) if (f(elem)) result.add(elem);
	return result;
}
